import { Button } from '@cian/ui-kit/button';
import { IconHeartOn16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import { useSaveSearchContext } from '../../../../../packages/SaveSearchModal';

export function SaveSearchButtonContainer() {
  const { onOpen } = useSaveSearchContext();

  return (
    <Button theme="fill_white_primary" size="XS" beforeIcon={<IconHeartOn16 color="primary_100" />} onClick={onOpen}>
      Сохранить поиск
    </Button>
  );
}

SaveSearchButtonContainer.displayName = 'SaveSearchButtonContainer';
